import sanityClient from '@sanity/client';

export default sanityClient({
	projectId: 'e5w4kak4',
	dataset: 'production',
	apiVersion: '2022-08-31', // you can change date here
	useCdn: true,
});
